module.exports = __webpack_public_path__ + "static/img/business.0f94cd5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/business.png
// module id = d2uF
// module chunks = 1